module.exports = __webpack_public_path__ + "static/media/39_NUSSU_Exco_Rep.f9cfd40f.jpg";